import React from "react";
import { Select } from "antd";

const StoreSelector = ({ options, value, onChange, width = "200px" }) => {
  return (
    <div className="mb-2">
      <Select
        showSearch
        options={options}
        value={value ? value : undefined}
        onChange={onChange}
        placeholder="Choose a Restaurant..."
        style={{ width: width}}
        className="custom-store-select "
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
      <style>{`
        .custom-store-select .ant-select-selector {
          cursor: pointer !important;
          border: 1px solid #000000 !important;
        }
          .custom-store-select .ant-select-selection-placeholder {
          color: #000000 !important; 
          opacity: 0.6; /* Thoda light black */
        }
      `}</style>
    </div>
  );
};

export default StoreSelector;